import React from 'react';
import { Box } from '@mui/material';
import Map from '../components/Map';

function MapPage() {
  return (
    <Box sx={{ height: 'calc(100vh - 64px)' }}>
      <Map />
    </Box>
  );
}

export default MapPage; 